"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Alpha3Countries = void 0;
var Alpha3Countries;
(function (Alpha3Countries) {
    /**
     * Afghanistan
     */
    Alpha3Countries["AFG"] = "AFG";
    /**
     * Åland Islands
     */
    Alpha3Countries["ALA"] = "ALA";
    /**
     * Albania
     */
    Alpha3Countries["ALB"] = "ALB";
    /**
     * Algeria
     */
    Alpha3Countries["DZA"] = "DZA";
    /**
     * American Samoa
     */
    Alpha3Countries["ASM"] = "ASM";
    /**
     * Andorra
     */
    Alpha3Countries["AND"] = "AND";
    /**
     * Angola
     */
    Alpha3Countries["AGO"] = "AGO";
    /**
     * Anguilla
     */
    Alpha3Countries["AIA"] = "AIA";
    /**
     * Antarctica
     */
    Alpha3Countries["ATA"] = "ATA";
    /**
     * Antigua and Barbuda
     */
    Alpha3Countries["ATG"] = "ATG";
    /**
     * Argentina
     */
    Alpha3Countries["ARG"] = "ARG";
    /**
     * Armenia
     */
    Alpha3Countries["ARM"] = "ARM";
    /**
     * Aruba
     */
    Alpha3Countries["ABW"] = "ABW";
    /**
     * Australia
     */
    Alpha3Countries["AUS"] = "AUS";
    /**
     * Austria
     */
    Alpha3Countries["AUT"] = "AUT";
    /**
     * Azerbaijan
     */
    Alpha3Countries["AZE"] = "AZE";
    /**
     * Bahamas
     */
    Alpha3Countries["BHS"] = "BHS";
    /**
     * Bahrain
     */
    Alpha3Countries["BHR"] = "BHR";
    /**
     * Bangladesh
     */
    Alpha3Countries["BGD"] = "BGD";
    /**
     * Barbados
     */
    Alpha3Countries["BRB"] = "BRB";
    /**
     * Belarus
     */
    Alpha3Countries["BLR"] = "BLR";
    /**
     * Belgium
     */
    Alpha3Countries["BEL"] = "BEL";
    /**
     * Belize
     */
    Alpha3Countries["BLZ"] = "BLZ";
    /**
     * Benin
     */
    Alpha3Countries["BEN"] = "BEN";
    /**
     * Bermuda
     */
    Alpha3Countries["BMU"] = "BMU";
    /**
     * Bhutan
     */
    Alpha3Countries["BTN"] = "BTN";
    /**
     * Bolivia (Plurinational State of)
     */
    Alpha3Countries["BOL"] = "BOL";
    /**
     * Bonaire, Sint Eustatius and Saba
     */
    Alpha3Countries["BES"] = "BES";
    /**
     * Bosnia and Herzegovina
     */
    Alpha3Countries["BIH"] = "BIH";
    /**
     * Botswana
     */
    Alpha3Countries["BWA"] = "BWA";
    /**
     * Bouvet Island
     */
    Alpha3Countries["BVT"] = "BVT";
    /**
     * Brazil
     */
    Alpha3Countries["BRA"] = "BRA";
    /**
     * British Indian Ocean Territory
     */
    Alpha3Countries["IOT"] = "IOT";
    /**
     * Brunei Darussalam
     */
    Alpha3Countries["BRN"] = "BRN";
    /**
     * Bulgaria
     */
    Alpha3Countries["BGR"] = "BGR";
    /**
     * Burkina Faso
     */
    Alpha3Countries["BFA"] = "BFA";
    /**
     * Burundi
     */
    Alpha3Countries["BDI"] = "BDI";
    /**
     * Cambodia
     */
    Alpha3Countries["KHM"] = "KHM";
    /**
     * Cameroon
     */
    Alpha3Countries["CMR"] = "CMR";
    /**
     * Canada
     */
    Alpha3Countries["CAN"] = "CAN";
    /**
     * Cabo Verde
     */
    Alpha3Countries["CPV"] = "CPV";
    /**
     * Cayman Islands
     */
    Alpha3Countries["CYM"] = "CYM";
    /**
     * Central African Republic
     */
    Alpha3Countries["CAF"] = "CAF";
    /**
     * Chad
     */
    Alpha3Countries["TCD"] = "TCD";
    /**
     * Chile
     */
    Alpha3Countries["CHL"] = "CHL";
    /**
     * China
     */
    Alpha3Countries["CHN"] = "CHN";
    /**
     * Christmas Island
     */
    Alpha3Countries["CXR"] = "CXR";
    /**
     * Cocos (Keeling) Islands
     */
    Alpha3Countries["CCK"] = "CCK";
    /**
     * Colombia
     */
    Alpha3Countries["COL"] = "COL";
    /**
     * Comoros
     */
    Alpha3Countries["COM"] = "COM";
    /**
     * Congo
     */
    Alpha3Countries["COG"] = "COG";
    /**
     * Congo (Democratic Republic of the)
     */
    Alpha3Countries["COD"] = "COD";
    /**
     * Cook Islands
     */
    Alpha3Countries["COK"] = "COK";
    /**
     * Costa Rica
     */
    Alpha3Countries["CRI"] = "CRI";
    /**
     * Côte d'Ivoire
     */
    Alpha3Countries["CIV"] = "CIV";
    /**
     * Croatia
     */
    Alpha3Countries["HRV"] = "HRV";
    /**
     * Cuba
     */
    Alpha3Countries["CUB"] = "CUB";
    /**
     * Curaçao
     */
    Alpha3Countries["CUW"] = "CUW";
    /**
     * Cyprus
     */
    Alpha3Countries["CYP"] = "CYP";
    /**
     * Czech Republic
     */
    Alpha3Countries["CZE"] = "CZE";
    /**
     * Denmark
     */
    Alpha3Countries["DNK"] = "DNK";
    /**
     * Djibouti
     */
    Alpha3Countries["DJI"] = "DJI";
    /**
     * Dominica
     */
    Alpha3Countries["DMA"] = "DMA";
    /**
     * Dominican Republic
     */
    Alpha3Countries["DOM"] = "DOM";
    /**
     * Ecuador
     */
    Alpha3Countries["ECU"] = "ECU";
    /**
     * Egypt
     */
    Alpha3Countries["EGY"] = "EGY";
    /**
     * El Salvador
     */
    Alpha3Countries["SLV"] = "SLV";
    /**
     * Equatorial Guinea
     */
    Alpha3Countries["GNQ"] = "GNQ";
    /**
     * Eritrea
     */
    Alpha3Countries["ERI"] = "ERI";
    /**
     * Estonia
     */
    Alpha3Countries["EST"] = "EST";
    /**
     * Eswatini
     */
    Alpha3Countries["SWZ"] = "SWZ";
    /**
     * Ethiopia
     */
    Alpha3Countries["ETH"] = "ETH";
    /**
     * Falkland Islands (Malvinas)
     */
    Alpha3Countries["FLK"] = "FLK";
    /**
     * Faroe Islands
     */
    Alpha3Countries["FRO"] = "FRO";
    /**
     * Fiji
     */
    Alpha3Countries["FJI"] = "FJI";
    /**
     * Finland
     */
    Alpha3Countries["FIN"] = "FIN";
    /**
     * France
     */
    Alpha3Countries["FRA"] = "FRA";
    /**
     * French Polynesia
     */
    Alpha3Countries["PYF"] = "PYF";
    /**
     * French Guiana
     */
    Alpha3Countries["GUF"] = "GUF";
    /**
     * French Southern Territories
     */
    Alpha3Countries["ATF"] = "ATF";
    /**
     * Gabon
     */
    Alpha3Countries["GAB"] = "GAB";
    /**
     * Gambia
     */
    Alpha3Countries["GMB"] = "GMB";
    /**
     * Georgia
     */
    Alpha3Countries["GEO"] = "GEO";
    /**
     * Germany
     */
    Alpha3Countries["DEU"] = "DEU";
    /**
     * Ghana
     */
    Alpha3Countries["GHA"] = "GHA";
    /**
     * Gibraltar
     */
    Alpha3Countries["GIB"] = "GIB";
    /**
     * Greece
     */
    Alpha3Countries["GRC"] = "GRC";
    /**
     * Greenland
     */
    Alpha3Countries["GRL"] = "GRL";
    /**
     * Grenada
     */
    Alpha3Countries["GRD"] = "GRD";
    /**
     * Guadeloupe
     */
    Alpha3Countries["GLP"] = "GLP";
    /**
     * Guam
     */
    Alpha3Countries["GUM"] = "GUM";
    /**
     * Guatemala
     */
    Alpha3Countries["GTM"] = "GTM";
    /**
     * Guernsey
     */
    Alpha3Countries["GGY"] = "GGY";
    /**
     * Guinea
     */
    Alpha3Countries["GIN"] = "GIN";
    /**
     * Guinea-Bissau
     */
    Alpha3Countries["GNB"] = "GNB";
    /**
     * Guyana
     */
    Alpha3Countries["GUY"] = "GUY";
    /**
     * Haiti
     */
    Alpha3Countries["HTI"] = "HTI";
    /**
     * Heard Island and McDonald Islands
     */
    Alpha3Countries["HMD"] = "HMD";
    /**
     * Holy See
     */
    Alpha3Countries["VAT"] = "VAT";
    /**
     * Honduras
     */
    Alpha3Countries["HND"] = "HND";
    /**
     * Hong Kong
     */
    Alpha3Countries["HKG"] = "HKG";
    /**
     * Hungary
     */
    Alpha3Countries["HUN"] = "HUN";
    /**
     * Iceland
     */
    Alpha3Countries["ISL"] = "ISL";
    /**
     * India
     */
    Alpha3Countries["IND"] = "IND";
    /**
     * Indonesia
     */
    Alpha3Countries["IDN"] = "IDN";
    /**
     * Iran (Islamic Republic of)
     */
    Alpha3Countries["IRN"] = "IRN";
    /**
     * Iraq
     */
    Alpha3Countries["IRQ"] = "IRQ";
    /**
     * Ireland
     */
    Alpha3Countries["IRL"] = "IRL";
    /**
     * Isle of Man
     */
    Alpha3Countries["IMN"] = "IMN";
    /**
     * Israel
     */
    Alpha3Countries["ISR"] = "ISR";
    /**
     * Italy
     */
    Alpha3Countries["ITA"] = "ITA";
    /**
     * Jamaica
     */
    Alpha3Countries["JAM"] = "JAM";
    /**
     * Japan
     */
    Alpha3Countries["JPN"] = "JPN";
    /**
     * Jersey
     */
    Alpha3Countries["JEY"] = "JEY";
    /**
     * Jordan
     */
    Alpha3Countries["JOR"] = "JOR";
    /**
     * Kazakhstan
     */
    Alpha3Countries["KAZ"] = "KAZ";
    /**
     * Kenya
     */
    Alpha3Countries["KEN"] = "KEN";
    /**
     * Kiribati
     */
    Alpha3Countries["KIR"] = "KIR";
    /**
     * Korea (Democratic People's Republic of)
     */
    Alpha3Countries["PRK"] = "PRK";
    /**
     * Korea (Republic of)
     */
    Alpha3Countries["KOR"] = "KOR";
    /**
     * Kuwait
     */
    Alpha3Countries["KWT"] = "KWT";
    /**
     * Kyrgyzstan
     */
    Alpha3Countries["KGZ"] = "KGZ";
    /**
     * Lao People's Democratic Republic
     */
    Alpha3Countries["LAO"] = "LAO";
    /**
     * Latvia
     */
    Alpha3Countries["LVA"] = "LVA";
    /**
     * Lebanon
     */
    Alpha3Countries["LBN"] = "LBN";
    /**
     * Lesotho
     */
    Alpha3Countries["LSO"] = "LSO";
    /**
     * Liberia
     */
    Alpha3Countries["LBR"] = "LBR";
    /**
     * Libya
     */
    Alpha3Countries["LBY"] = "LBY";
    /**
     * Liechtenstein
     */
    Alpha3Countries["LIE"] = "LIE";
    /**
     * Lithuania
     */
    Alpha3Countries["LTU"] = "LTU";
    /**
     * Luxembourg
     */
    Alpha3Countries["LUX"] = "LUX";
    /**
     * Macao
     */
    Alpha3Countries["MAC"] = "MAC";
    /**
     * Macedonia (the former Yugoslav Republic of)
     */
    Alpha3Countries["MKD"] = "MKD";
    /**
     * Madagascar
     */
    Alpha3Countries["MDG"] = "MDG";
    /**
     * Malawi
     */
    Alpha3Countries["MWI"] = "MWI";
    /**
     * Malaysia
     */
    Alpha3Countries["MYS"] = "MYS";
    /**
     * Maldives
     */
    Alpha3Countries["MDV"] = "MDV";
    /**
     * Mali
     */
    Alpha3Countries["MLI"] = "MLI";
    /**
     * Malta
     */
    Alpha3Countries["MLT"] = "MLT";
    /**
     * Marshall Islands
     */
    Alpha3Countries["MHL"] = "MHL";
    /**
     * Martinique
     */
    Alpha3Countries["MTQ"] = "MTQ";
    /**
     * Mauritania
     */
    Alpha3Countries["MRT"] = "MRT";
    /**
     * Mauritius
     */
    Alpha3Countries["MUS"] = "MUS";
    /**
     * Mayotte
     */
    Alpha3Countries["MYT"] = "MYT";
    /**
     * Mexico
     */
    Alpha3Countries["MEX"] = "MEX";
    /**
     * Micronesia (Federated States of)
     */
    Alpha3Countries["FSM"] = "FSM";
    /**
     * Moldova (Republic of)
     */
    Alpha3Countries["MDA"] = "MDA";
    /**
     * Monaco
     */
    Alpha3Countries["MCO"] = "MCO";
    /**
     * Mongolia
     */
    Alpha3Countries["MNG"] = "MNG";
    /**
     * Montenegro
     */
    Alpha3Countries["MNE"] = "MNE";
    /**
     * Montserrat
     */
    Alpha3Countries["MSR"] = "MSR";
    /**
     * Morocco
     */
    Alpha3Countries["MAR"] = "MAR";
    /**
     * Mozambique
     */
    Alpha3Countries["MOZ"] = "MOZ";
    /**
     * Myanmar
     */
    Alpha3Countries["MMR"] = "MMR";
    /**
     * Namibia
     */
    Alpha3Countries["NAM"] = "NAM";
    /**
     * Nauru
     */
    Alpha3Countries["NRU"] = "NRU";
    /**
     * Nepal
     */
    Alpha3Countries["NPL"] = "NPL";
    /**
     * Netherlands
     */
    Alpha3Countries["NLD"] = "NLD";
    /**
     * New Caledonia
     */
    Alpha3Countries["NCL"] = "NCL";
    /**
     * New Zealand
     */
    Alpha3Countries["NZL"] = "NZL";
    /**
     * Nicaragua
     */
    Alpha3Countries["NIC"] = "NIC";
    /**
     * Niger
     */
    Alpha3Countries["NER"] = "NER";
    /**
     * Nigeria
     */
    Alpha3Countries["NGA"] = "NGA";
    /**
     * Niue
     */
    Alpha3Countries["NIU"] = "NIU";
    /**
     * Norfolk Island
     */
    Alpha3Countries["NFK"] = "NFK";
    /**
     * Northern Mariana Islands
     */
    Alpha3Countries["MNP"] = "MNP";
    /**
     * Norway
     */
    Alpha3Countries["NOR"] = "NOR";
    /**
     * Oman
     */
    Alpha3Countries["OMN"] = "OMN";
    /**
     * Pakistan
     */
    Alpha3Countries["PAK"] = "PAK";
    /**
     * Palau
     */
    Alpha3Countries["PLW"] = "PLW";
    /**
     * Palestine, State of
     */
    Alpha3Countries["PSE"] = "PSE";
    /**
     * Panama
     */
    Alpha3Countries["PAN"] = "PAN";
    /**
     * Papua New Guinea
     */
    Alpha3Countries["PNG"] = "PNG";
    /**
     * Paraguay
     */
    Alpha3Countries["PRY"] = "PRY";
    /**
     * Peru
     */
    Alpha3Countries["PER"] = "PER";
    /**
     * Philippines
     */
    Alpha3Countries["PHL"] = "PHL";
    /**
     * Pitcairn
     */
    Alpha3Countries["PCN"] = "PCN";
    /**
     * Poland
     */
    Alpha3Countries["POL"] = "POL";
    /**
     * Portugal
     */
    Alpha3Countries["PRT"] = "PRT";
    /**
     * Puerto Rico
     */
    Alpha3Countries["PRI"] = "PRI";
    /**
     * Qatar
     */
    Alpha3Countries["QAT"] = "QAT";
    /**
     * Réunion
     */
    Alpha3Countries["REU"] = "REU";
    /**
     * Romania
     */
    Alpha3Countries["ROU"] = "ROU";
    /**
     * Russian Federation
     */
    Alpha3Countries["RUS"] = "RUS";
    /**
     * Rwanda
     */
    Alpha3Countries["RWA"] = "RWA";
    /**
     * Saint Barthélemy
     */
    Alpha3Countries["BLM"] = "BLM";
    /**
     * Saint Helena, Ascension and Tristan da Cunha
     */
    Alpha3Countries["SHN"] = "SHN";
    /**
     * Saint Kitts and Nevis
     */
    Alpha3Countries["KNA"] = "KNA";
    /**
     * Saint Lucia
     */
    Alpha3Countries["LCA"] = "LCA";
    /**
     * Saint Martin (French part)
     */
    Alpha3Countries["MAF"] = "MAF";
    /**
     * Saint Pierre and Miquelon
     */
    Alpha3Countries["SPM"] = "SPM";
    /**
     * Saint Vincent and the Grenadines
     */
    Alpha3Countries["VCT"] = "VCT";
    /**
     * Samoa
     */
    Alpha3Countries["WSM"] = "WSM";
    /**
     * San Marino
     */
    Alpha3Countries["SMR"] = "SMR";
    /**
     * Sao Tome and Principe
     */
    Alpha3Countries["STP"] = "STP";
    /**
     * Saudi Arabia
     */
    Alpha3Countries["SAU"] = "SAU";
    /**
     * Senegal
     */
    Alpha3Countries["SEN"] = "SEN";
    /**
     * Serbia
     */
    Alpha3Countries["SRB"] = "SRB";
    /**
     * Seychelles
     */
    Alpha3Countries["SYC"] = "SYC";
    /**
     * Sierra Leone
     */
    Alpha3Countries["SLE"] = "SLE";
    /**
     * Singapore
     */
    Alpha3Countries["SGP"] = "SGP";
    /**
     * Sint Maarten (Dutch part)
     */
    Alpha3Countries["SXM"] = "SXM";
    /**
     * Slovakia
     */
    Alpha3Countries["SVK"] = "SVK";
    /**
     * Slovenia
     */
    Alpha3Countries["SVN"] = "SVN";
    /**
     * Solomon Islands
     */
    Alpha3Countries["SLB"] = "SLB";
    /**
     * Somalia
     */
    Alpha3Countries["SOM"] = "SOM";
    /**
     * South Africa
     */
    Alpha3Countries["ZAF"] = "ZAF";
    /**
     * South Georgia and the South Sandwich Islands
     */
    Alpha3Countries["SGS"] = "SGS";
    /**
     * South Sudan
     */
    Alpha3Countries["SSD"] = "SSD";
    /**
     * Spain
     */
    Alpha3Countries["ESP"] = "ESP";
    /**
     * Sri Lanka
     */
    Alpha3Countries["LKA"] = "LKA";
    /**
     * Sudan
     */
    Alpha3Countries["SDN"] = "SDN";
    /**
     * Suriname
     */
    Alpha3Countries["SUR"] = "SUR";
    /**
     * Svalbard and Jan Mayen
     */
    Alpha3Countries["SJM"] = "SJM";
    /**
     * Sweden
     */
    Alpha3Countries["SWE"] = "SWE";
    /**
     * Switzerland
     */
    Alpha3Countries["CHE"] = "CHE";
    /**
     * Syrian Arab Republic
     */
    Alpha3Countries["SYR"] = "SYR";
    /**
     * Taiwan (Province of China)
     */
    Alpha3Countries["TWN"] = "TWN";
    /**
     * Tajikistan
     */
    Alpha3Countries["TJK"] = "TJK";
    /**
     * Tanzania, United Republic of
     */
    Alpha3Countries["TZA"] = "TZA";
    /**
     * Thailand
     */
    Alpha3Countries["THA"] = "THA";
    /**
     * Timor-Leste
     */
    Alpha3Countries["TLS"] = "TLS";
    /**
     * Togo
     */
    Alpha3Countries["TGO"] = "TGO";
    /**
     * Tokelau
     */
    Alpha3Countries["TKL"] = "TKL";
    /**
     * Tonga
     */
    Alpha3Countries["TON"] = "TON";
    /**
     * Trinidad and Tobago
     */
    Alpha3Countries["TTO"] = "TTO";
    /**
     * Tunisia
     */
    Alpha3Countries["TUN"] = "TUN";
    /**
     * Turkey
     */
    Alpha3Countries["TUR"] = "TUR";
    /**
     * Turkmenistan
     */
    Alpha3Countries["TKM"] = "TKM";
    /**
     * Turks and Caicos Islands
     */
    Alpha3Countries["TCA"] = "TCA";
    /**
     * Tuvalu
     */
    Alpha3Countries["TUV"] = "TUV";
    /**
     * Uganda
     */
    Alpha3Countries["UGA"] = "UGA";
    /**
     * Ukraine
     */
    Alpha3Countries["UKR"] = "UKR";
    /**
     * United Arab Emirates
     */
    Alpha3Countries["ARE"] = "ARE";
    /**
     * United Kingdom of Great Britain and Northern Ireland
     */
    Alpha3Countries["GBR"] = "GBR";
    /**
     * United States of America
     */
    Alpha3Countries["USA"] = "USA";
    /**
     * United States Minor Outlying Islands
     */
    Alpha3Countries["UMI"] = "UMI";
    /**
     * Uruguay
     */
    Alpha3Countries["URY"] = "URY";
    /**
     * Uzbekistan
     */
    Alpha3Countries["UZB"] = "UZB";
    /**
     * Vanuatu
     */
    Alpha3Countries["VUT"] = "VUT";
    /**
     * Venezuela (Bolivarian Republic of)
     */
    Alpha3Countries["VEN"] = "VEN";
    /**
     * Viet Nam
     */
    Alpha3Countries["VNM"] = "VNM";
    /**
     * Virgin Islands (British)
     */
    Alpha3Countries["VGB"] = "VGB";
    /**
     * Virgin Islands (U.S.)
     */
    Alpha3Countries["VIR"] = "VIR";
    /**
     * Wallis and Futuna
     */
    Alpha3Countries["WLF"] = "WLF";
    /**
     * Western Sahara
     */
    Alpha3Countries["ESH"] = "ESH";
    /**
     * Yemen
     */
    Alpha3Countries["YEM"] = "YEM";
    /**
     * Zambia
     */
    Alpha3Countries["ZMB"] = "ZMB";
    /**
     * Zimbabwe
     */
    Alpha3Countries["ZWE"] = "ZWE";
    /**
     * Rest of World (for special cases, or not otherwise classified)
     */
    Alpha3Countries["ROW"] = "ROW";
})(Alpha3Countries || (exports.Alpha3Countries = Alpha3Countries = {}));
//# sourceMappingURL=countries.js.map